import type { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";

/** Avoid mounting a protected screen until its matching API permission is known. */
export default function PermissionBoundary({ permissions, children }: { permissions: string[]; children: ReactNode }) {
  const { permissionsLoaded, hasPermission, isSuperAdmin } = useAuth();
  if (isSuperAdmin) return <>{children}</>;
  if (!permissionsLoaded) return <p role="status" className="p-6 text-sm text-muted-foreground">Loading access permissions…</p>;
  if (!permissions.some(hasPermission)) return <p role="alert" className="p-6 text-sm text-muted-foreground">You do not have permission to access this page. Ask your administrator to review your access.</p>;
  return <>{children}</>;
}
